<template>
    <div class="mb-6 mb-md-5 card movie-card">
        <b-modal v-if="trailer"
                 class="movie-card-modal"
                 :id="idPrefix + '-trailer-modal' + duplicateCounter"
                 :hide-footer="true"
                 size="lg"
                 :title="'\'' + title + '\' trailer'"
                 :lazy="true"
                 @show="modalShow"
                 @hide="modalHide">
            <b-embed :type="getHtmlTag()"
                     aspect="16by9"
                     :src="trailer"
                     allowfullscreen
                     controls
                     autoplay
                     allow="autoplay"
            >
            </b-embed>
        </b-modal>

        <div v-if="showHeader && headerText" class="mt-5 mt-md-0 h3-title font-weight-semibold movie-card-header">
            {{ headerText }}
        </div>

        <div v-if="! showHeader || ! headerText" class="movie-card-header movie-card-header-empty" :class="{ 'movie-card-header-hidden': (! showHeader) }"></div>

        <h3 class="d-none d-md-block m-0 font-weight-semibold font-size-default min-height-40">
            <a :href="singleUrl" v-html="cutOffString(title, 20)"></a>
        </h3>

        <div class="row mt-3 d-md-none">
            <a class="d-block col-4 col-sm-3 pr-0 movie-card-poster" :href="singleUrl">
                <img class="img-fluid" :src="poster" :alt="title">
            </a>

            <div class="col-8 col-sm-9">
                <h3 class="font-weight-semibold font-size-medium">
                    <a :href="singleUrl">
                        {{ title }}
                    </a>
                </h3>

                <div v-if="oneliner" class="d-sm-none mt-3 font-size-small" v-html="cutOffString(oneliner, 75)"></div>
                <div v-if="oneliner" class="d-none d-sm-block mt-3 font-size-small" v-html="oneliner"></div>
                <div v-if="!oneliner && description" class="d-sm-none mt-3 font-size-small" v-html="cutOffString(description, 75)"></div>
                <div v-if="!oneliner && description" class="d-none d-sm-block mt-3 font-size-small" v-html="cutOffString(description, 75)"></div>

                <div class="mt-3 movie-card-buttons">
                    <a class="mt-sm-0 btn btn-secondary size-small" :href="singleUrl">
                        Meer info
                    </a>

                    <b-btn v-if="trailer" v-b-modal="idPrefix + '-trailer-modal' + duplicateCounter" class="btn btn-secondary size-small">
                        Bekijk trailer
                    </b-btn>
                </div>
            </div>
        </div>

        <div class="mt-3 d-none d-md-block movie-card-poster">
            <img class="img-fluid" :src="poster" :alt="title">

            <div class="movie-card-details text-left">
                <a :href="singleUrl" class="font-weight-extrabold font-size-small color-inherit" v-html="cutOffString(title, 25)"></a>

                <div v-if="oneliner" class="mt-3 font-size-tiny color-brown" v-html="cutOffString(oneliner, 60)"></div>
                <div v-if="!oneliner && description" class="mt-3 font-size-tiny color-brown" v-html="cutOffString(description, 60)"></div>
                <div class="mt-4 text-center movie-card-buttons">
                    <a class="btn btn-secondary" :href="singleUrl">
                        Meer info
                    </a>

                    <br class="d-sm-none">

                    <b-btn v-if="trailer" v-b-modal="idPrefix + '-trailer-modal' + duplicateCounter" class="mt-3 btn btn-secondary">
                        Bekijk trailer
                    </b-btn>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row">
                <div v-if="showTimes" v-for="time in times.slice(0, 2)" class="col-6 col-md-12 mt-3 pl-3 movie-card-times">
                    <div v-if="time.screen" class="movie-card-screen">
                        {{ time.screen.toUpperCase() }}
                    </div>

                    <div v-if="!time.ticketUrl">
                        <span v-if="showDayInTimes" class="font-size-small">
                            {{ time.day }}
                        </span>
                            <span class="font-weight-extrabold">
                            {{ time.time }}
                        </span>
                    </div>

                    <a v-if="time.ticketUrl" :href="time.ticketUrl" target="_blank" class="ticket-url">
                        <span v-if="showDayInTimes" class="font-size-small">
                            {{ time.day }}
                        </span>
                        <span class="font-weight-extrabold time-label">
                            {{ time.time }}

                        </span>
                        <span class="ticket-notice d-none">Reserveer</span>
                    </a>

                    <div v-if="showCinemaName && time.cinemaName">
                        <a class="color-inherit" :href="'/bioscoop/' + time.cinemaSlug">
                            {{ time.cinemaName }}
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <a v-if="showTimes && times.length > 2" class="mt-3 d-block collapsed color-grey--dark variable-collapse-button"
           :href="'#more-times-' + _uid"
           role="button"
           data-toggle="collapse"
           aria-expanded="false"
           :aria-controls="'more-times-' + _uid">
            <span class="not-collapsed">
                Minder tijden<i class="ml-3 fas fa-angle-up"></i>
            </span>

            <span class="is-collapsed">
                Meer tijden<i class="ml-3 fas fa-angle-down"></i>
            </span>
        </a>

        <div v-if="showTimes && times.length > 2" class="collapse" :id="'more-times-' + _uid">
            <div class="container">
                <div class="row">
                    <div v-for="time in times.slice(2)" class="col-6 col-md-12 mt-3 pl-3 movie-card-times">
                        <div v-if="time.screen" class="movie-card-screen">
                            {{ time.screen.toUpperCase() }}
                        </div>

                        <div v-if="!time.ticketUrl" class="font-weight-extrabold">
                            <span v-if="showDayInTimes">
                                {{ time.day }}:
                            </span>
                            {{ time.time }}
                        </div>

                        <a v-if="time.ticketUrl" :href="time.ticketUrl" class="font-weight-extrabold ticket-url" target="_blank">
                            <span v-if="showDayInTimes">
                                {{ time.day }}:
                            </span>
                            <span class="time-label">
                                {{ time.time }}

                            </span>
                            <span class="ticket-notice d-none">Reserveer</span>
                        </a>

                        <div v-if="showCinemaName && time.cinemaName">
                            <a class="color-inherit" :href="'/bioscoop/' + time.cinemaSlug">
                                {{ time.cinemaName }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            idPrefix: {
                type: String|Number,
                required: true,
            },
            showHeader: {
                type: Boolean,
                default: true,
            },
            showTimes: {
                type: Boolean,
                default: true,
            },
            showCinemaName: {
                type: Boolean,
                default: true,
            },
            duplicateCounter: {
                type: Number
            },
            headerText: {
                type: String,
                default: null,
            },
            poster: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            oneliner: {
                type: String,
            },
            description: {
                type: String,
            },
            singleUrl: {
                type: String,
                required: true,
            },
            trailer: {
                type: String,
            },
            useIframeTag: {
                type: Boolean,
                default: false,
            },
            // Times are a {cinemaName, cinemaSlug, time, ticketUrl, screen} object, cinema name and screen are optional
            times: {
                type: Array,
                required: true,
            },
            showDayInTimes: {
                type: Boolean,
                default: false,
            },
            // Ratings are icon URL strings
            ratings: {
                type: Array,
            },
        },
        methods: {
            /**
             * Hide the filter buttons, when the modal is open
             * @param bvEvt
             */
            modalShow: bvEvt => {
                $('.hide-during-trailer-modal').addClass('d-none');
            },

            /**
             * Get embed video HTML tag
             */
            getHtmlTag() {
                return this.useIframeTag ? 'iframe' : 'video';
            },

            /**
             * Show the filter buttons again, when the modal is closed
             * @param bvEvt
             */
            modalHide: bvEvt => {
                $('.hide-during-trailer-modal').removeClass('d-none');
            },
            cutOffString: (string, length, append = '&hellip;') => {
                return MrMovie.utils.cutOffString(string, length, append);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/movies/MovieCard.vue